// Shared static props for recharts/framer-motion so renders don't allocate new objects
export const AXIS_TICK = { fill: "#71717a", fontSize: 10 };
export const TOOLTIP_STYLE = { background: "#050505", border: "1px solid #2A2411", fontSize: 12 };
export const BAR_CURSOR = { fill: "#2A241155" };
export const BAR_TOP_RADIUS = [3, 3, 0, 0];
export const DOMAIN_DATA = ["dataMin", "dataMax"];
export const DOMAIN_AUTO = ["auto", "auto"];
export const FADE_UP = { initial: { opacity: 0, y: 20 }, animate: { opacity: 1, y: 0 } };
export const FADE_UP_SM = { initial: { opacity: 0, y: 16 }, animate: { opacity: 1, y: 0 } };
export const HERO_TRANSITION = { duration: 0.5 };
